import { InputNumber } from "antd";
import React, { forwardRef } from "react";
import styled from "styled-components";
import { CustomInputNumberProps } from "../../../../components/atoms/InputNumber";
import { theme } from "../../../../theme";

interface Props extends CustomInputNumberProps {}
const CustomInputNumber: React.FC<Props> = forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    const { min, ...rest } = props;
    return (
      <StyledInputNumber
        max={100}
        stringMode
        min={0}
        parser={(e) => {
          return Math.floor(Number(e));
        }}
        ref={ref}
        bordered={false}
        {...rest}
      />
    );
  }
);
export default CustomInputNumber;

CustomInputNumber.defaultProps = { controls: false };
const StyledInputNumber = styled(InputNumber)`
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #cdcdcd;
  border-radius: 0px;
  display: flex;
  align-items: center;
  width: 100%;
  .ant-input-number-input::placeholder {
    ${theme.typo.body.r14};
  }
  ${theme.typo.body.r16};
  &:hover {
    border-bottom: 1px solid #cdcdcd;
  }
  .ant-input-number-input-wrap {
    width: 100%;
  }
`;
